// SettingsDigits.js
import React, { useRef, useEffect } from "react";
import "../assets/FlowTimer.css";

const SettingsDigits = ({
  value,
  isFlashing = false,
  brightnessFactor = 1,
  volume = 5,
  tone = 1,
  inSettings
}) => {
  const audioRef = useRef(null);
  const didMountRef = useRef(false); // <-- Tracks if we've already rendered once

  const getToneSrc = (toneNumber) => {
    switch (toneNumber) {
      case 1: return "/tones/FocusFlo Tone 1 - Upbeat.mp3";
      case 2: return "/tones/FocusFlo Tone 2 - Chime.mp3";
      case 3: return "/tones/FocusFlo Tone 3 - Beep.mp3";
      case 4: return "/tones/FocusFlo Tone 4 - SingingBowl.mp3";
      case 5: return "/tones/FocusFlo Tone 5 - LofiShort.mp3";
      case 6: return "/tones/FocusFlo Tone 6 - Rain.mp3";
      case 7: return "/tones/FocusFlo Tone 7 - Simple.mp3";
      case 8: return "/tones/FocusFlo Tone 8 - Alert.mp3";
      default: return "/tones/FocusFlo Tone 1 - Upbeat.mp3";
    }
  };



  // On volume/tone change, attempt to play audio only if NOT the very first render
  useEffect(() => {
    if (!audioRef.current) return;

    if (!didMountRef.current) {
      // The first time this runs, skip the audio preview
      didMountRef.current = true;
      return;
    }

    // If we're here, it means volume/tone changed on a subsequent render
    const actualVolume = (volume - 1) * 0.25;
    audioRef.current.volume = actualVolume;
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch((err) => console.error("Audio playback failed:", err));
  }, [volume, tone]);

  const twoDigitString = value.toString().padStart(2, "0");
  const renderDigits = () => {
    return twoDigitString.split("").map((char, index) => (
      <img
        key={index}
        src={`/figures/f${char}.svg`}
        alt={`digit-${char}`}
        className="timerDigit"
      />
    ));
  };

  return (
    <div
      className={`settingsDigitMenu timerDisplay ${isFlashing ? "flashing" : ""}`}
      style={{ filter: `brightness(${brightnessFactor})`,
      display: inSettings ? "block" : "none" }}
    >
      {renderDigits()}

      {/* Hidden audio element for preview */}
      <audio ref={audioRef} src={getToneSrc(tone)} />
    </div>
  );
};

export default SettingsDigits;
